import { useDispatch, useSelector } from 'react-redux'

import { dismissValidationError } from 'actions/errors'
import { inviteeEmailErrorsSelector } from 'selectors'
import BookingField from 'components/enter_details/booking_field'
import BookingTextField from 'components/form/text'
import { useI18n } from 'locales'

export const EmailInput = ({ email: { value, required }, onChange }) => {
  const { i18n } = useI18n()
  const emailErrors = useSelector(inviteeEmailErrorsSelector)
  const dispatch = useDispatch()
  const dismissError = () => dispatch(dismissValidationError('invitee', 'email'))

  const handleChange = (...args) => {
    dismissError()
    onChange(...args)
  }

  return (
    <BookingField>
      <BookingTextField
        id="email_input"
        label={i18n.t('booking.templates.email')}
        type="email"
        name="email"
        value={value}
        required={required}
        onChange={handleChange}
        error={emailErrors?.[0]}
        autoComplete="email"
      />
    </BookingField>
  )
}
